/* src/app/private/components/leads/lead-form/lead-form.component.scss */
.requiredValue::after {
  content: "*";
  color: red;
}
label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
.display-none {
  display: none;
}
/*# sourceMappingURL=lead-form.component.css.map */
